import React from 'react';
import { User, Shield, LogOut, Gamepad2, Sparkles, MessageCircle, Terminal, Handshake, HelpCircle } from 'lucide-react';
import GphRichBlock from '../GphRichBlock';
import { SUPPORT_COMMUNITY_URL } from '../../../services/gph/gphCopy';

export default function ProfileSettingsAdapter({ agent }) {
  const { host } = agent;
  const userEmail = host.user?.email || 'Usuário Autenticado';
  const canonicalGame = host.canonicalGame === 'free_fire' ? 'Free Fire' : 'PUBG Mobile';
  const isPro = host.entitlements?.isPro === true;

  const showAdmin = host.hasAdminPanelAccess === true;
  const showPartner = host.isPartnerUser === true;

  return (
    <GphRichBlock eyebrow="Configurações" title="SUA CONTA" subtitle="Conta, jogo principal e preferências.">
      <div className="space-y-6 pt-2 text-left">
        {/* Account Data */}
        <div className="flex items-center justify-between border-b border-white/5 pb-4">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-lime-500/10 border border-lime-500/30 flex items-center justify-center text-lime-400">
              <User size={16} />
            </div>
            <div>
              <span className="text-xs font-bold text-white block">{userEmail}</span>
              <span className="text-[10px] text-slate-500 font-mono">ID: {host.user?.uid?.slice(0, 10) || 'GPH-OPERATOR'}</span>
            </div>
          </div>
          <span className={`px-2 py-0.5 rounded text-[10px] font-extrabold uppercase border ${
            isPro ? 'bg-lime-500/20 text-lime-400 border-lime-500/40' : 'bg-transparent text-slate-400 border-white/5'
          }`}>
            {isPro ? 'Membro Pro' : 'Plano Free'}
          </span>
        </div>

        {/* Game Focus Preferences */}
        <div className="space-y-2">
          <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 block flex items-center gap-1.5">
            <Gamepad2 size={13} className="text-lime-400" /> Jogo Principal em Foco
          </span>
          <div className="flex items-center justify-between py-2 border-b border-white/5">
            <span className="text-xs font-mono font-bold text-white">{canonicalGame}</span>
            <span className="text-[10px] text-slate-500">Sincronizado na IA</span>
          </div>
        </div>

        {/* CONTROL PANEL SECTIONS FOR ADMIN / PARTNER (P0) */}
        {(showAdmin || showPartner) && (
          <div className="space-y-3">
            <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 block">Painéis de Controle</span>
            <div className="flex flex-wrap gap-3">
              {showAdmin && (
                <button
                  type="button"
                  onClick={() => host.openAdminPanel?.()}
                  className="gph-btn gph-btn--primary text-xs flex items-center gap-1.5"
                >
                  <Terminal size={14} /> Painel ADM
                </button>
              )}
              {showPartner && (
                <button
                  type="button"
                  onClick={() => host.openPartnerPanel?.()}
                  className="gph-btn gph-btn--primary text-xs flex items-center gap-1.5"
                >
                  <Handshake size={14} /> Painel Parceiro
                </button>
              )}
            </div>
          </div>
        )}

        {/* SUPPORT AND COMMUNITY RESOURCES (P0) */}
        <div className="space-y-3">
          <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 block flex items-center gap-1.5">
            <HelpCircle size={13} className="text-lime-400" /> Suporte & Comunidade
          </span>
          <div className="flex flex-wrap gap-3">
            <a
              href={SUPPORT_COMMUNITY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="gph-btn gph-btn--ghost text-xs flex items-center gap-1.5"
            >
              <MessageCircle size={14} /> Entrar na Comunidade
            </a>
            <a
              href={SUPPORT_COMMUNITY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="gph-btn gph-btn--ghost text-xs flex items-center gap-1.5"
            >
              <HelpCircle size={14} /> Falar com Suporte
            </a>
          </div>
        </div>

        {/* Actions */}
        <div className="border-t border-white/5 pt-5 mt-6 flex flex-wrap gap-3 items-center justify-between">
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => agent.runCapability('profile_plan', {})}
              className="gph-btn gph-btn--ghost text-xs"
            >
              <Shield size={14} /> Ver Meus Limites
            </button>
            {!isPro && (
              <button
                type="button"
                onClick={() => agent.runCapability('purchase_pro', {})}
                className="gph-btn gph-btn--primary text-xs flex items-center gap-1.5"
              >
                <Sparkles size={14} /> Virar Pro
              </button>
            )}
          </div>
          {typeof host.signOut === 'function' && (
            <button
              type="button"
              onClick={host.signOut}
              className="text-xs text-rose-400 hover:text-rose-300 flex items-center gap-1 py-1 font-mono underline ml-auto"
            >
              <LogOut size={13} /> Sair da Conta
            </button>
          )}
        </div>
      </div>
    </GphRichBlock>
  );
}
